import BaseAPI from './base'

class LearningConfigAPI extends BaseAPI {}

export default new LearningConfigAPI('v1/learning-configs', 'LearningConfig')
